module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"invaild_image":"の拡張子は対応していません。","post":"投稿する"}}')
  delete Component.options._Ctor
}
